import React from "react";
import {Translation} from "react-i18next";
import GetAppIcon from '@material-ui/icons/GetApp';

export default class SurveyPDFQuestionCell extends React.Component{
  
  // Instance Variables
  
  inputRef = React.createRef();
  
  // Init
  
  constructor(props){
    super(props);
    this.state = {
      file:null,
      pdfUrl:null
    };
    if(props.answer != null){
      if(props.answer.value != null) {
        this.state.pdfUrl = props.answer.value;
      }
      if(props.answer.file != null){
        this.state.file = props.answer.file;
        this.state.pdfUrl = URL.createObjectURL(this.state.file);
      }
    }
    this.buttonClicked = this.buttonClicked.bind(this);
    this.handleFileUpload = this.handleFileUpload.bind(this);
  }
  
  // Methods
  
  buttonClicked(){
    this.inputRef.current.click();
  }
  
  handleFileUpload(aEvent){
    let file = aEvent.target.files[0];
    this.setState({file:file});
    this.props.onAnswerChange(this.props.question, this.state.pdfUrl, null, null, null, true, file);
  }
  
  // Render
  
  render(){
    const {disabled, question} = this.props;
    const {file, pdfUrl} = this.state;
    const {key, type} = question;
    
    return(
      <div className="survey-question-file-cell"
           key={'survey-' + type + '-question-cell-' + key}>
        <input type="file"
               ref={this.inputRef}
               style={{display:'none'}}
               accept=".pdf"
               disabled={disabled}
               onChange={this.handleFileUpload}
        />
      
        {file ?
          <p className="survey-question-file-name">
            {file.name}
          </p>
          :
          pdfUrl ?
            <div className="survey-question-file-container">
              <a className="survey-question-file-button-upload"
                 rel="noreferrer"
                 href={pdfUrl}
                 target="_blank"
                 download="My_File.pdf">
                <GetAppIcon style={{fontSize:'20px'}}/>
                
                <Translation>{ (t, { i18n }) => t('DOWNLOAD_PDF')}</Translation>
              </a>
            </div>
            :
            null
        }
      
        <button className={'survey-button green-button survey-question-file-button'}
                disabled={disabled}
                onClick={this.buttonClicked}>
          {file || pdfUrl ?
            <Translation>{ (t, { i18n }) => t('CHANGE_PDF')}</Translation>
            :
            <Translation>{ (t, { i18n }) => t('SELECT_PDF')}</Translation>
          }
        </button>
      </div>
    )
  }
}
